module.exports = __webpack_public_path__ + "static/media/DancerLogo.b8e88573.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/logos/DancerLogo.jpg
// module id = 1001
// module chunks = 0